import {ErrorIconWithoutFill} from '../../../icons'
import './index.scss'

const Error = ({error, hasIcon}) => {
    return (
        <div className='error-field'>
            {hasIcon &&
            <span><ErrorIconWithoutFill/></span>}
            <span className="form-error" dangerouslySetInnerHTML={{__html: error}}/>
        </div>
    )
}

export default Error
